import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const SanalGarajIslemleri = () => {

  return (
    <div>SanalGarajIslemleri</div>
  )
}

export default SanalGarajIslemleri